/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { convertKeysToSnakeCase, empty, errorResponse, getInputDateFormat, isArray, prepareResponseData } from "../../Utilities/utils";
import { Toast } from "primereact/toast";

// css
import "../students/Students.css";

// api
import sessionApi from "../../api/Session";
import termApi from "../../api/Terms";
import studentApi from "../../api/Student";
import classApi from "../../api/Classes";
import staffApi from "../../api/Staff";
import parentsApi from "../../api/Parents";
import feeApi from "../../api/Fees";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import FullPageLoader from "../../components/loader/FullPageLoader";
import InputField from "../../components/form/InputField";
import { AuthContext } from "../Root/ProtectedRoute";
import SelectField from "../../components/form/SelectField";
import { Editor } from "primereact/editor";
import Header4 from "../../components/headers/Header4";
import colors from "../../config/colors";
import MultiSelectField from "../../components/form/MultiSelectField";
import FeeWrapper from "../../components/appWrapper/FeeWrapper";

// data
import { yesNo } from "../../data/yesNo";
import { applicableGroups } from "../../data/InputData";
import { FaPlus, FaTimesCircle } from "react-icons/fa";
import InputFieldChange from "../../components/form/InputFieldChange";

const required = "This field is required!";

const AddUpdateFee = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { feeId } = useParams();
  const toastTR = useRef(null);
  const [initialValues, setInitialValues] = useState({
  title: "",
  applicable_groups: [],
  class_ids: [],
  student_ids: [],
  staff_ids: [],
  term_id: '',
  session_id: '',
  start_date: '',
  end_date: '',
  status: ''
});

  const [students, setStudents] = useState([]);
  const [parents, setParents] = useState([]);
  const [staff, setStaff] = useState([]);
  const [classes, setClasses] = useState([]);
  const [ sessions, setSessions ] = useState([]);
  const [terms, setTerms] = useState([]);
  const [feeCategories, setFeeCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ feeDescription, setFeeDescription ] = useState('');
  const [feeEntries, setFeeEntries] = useState([{ id: 1 }]);
  const [fees, setFees] = useState({});

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    getSessions();
    getTerms();
    getFeeCategories();
    if (feeId) {
      getFeeDetails();
    }
  }, []);

const validationSchema = Yup.object().shape({
  title: Yup.string().required(required),
  applicable_groups: Yup.array().required(required),
  class_ids: Yup.array().optional(),
  student_ids: Yup.array().optional(),
  staff_ids: Yup.array().optional(),
  term_id: Yup.string().required(required),
  session_id: Yup.string().required(required),
  status: Yup.string().required(required),
  start_date: Yup.string().optional(),
  end_date: Yup.string().optional()
});


  /**
   * Get Fee Category
   * @returns 
   */
  const getFeeCategories = async () => {
    try {
      const response = await feeApi.getFeeCategories();
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setFeeCategories([]);
      } else {
        setFeeCategories(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    }
  };

  /**
   * Get sessions
   * @returns 
   */
  const getSessions = async () => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await sessionApi.getSessions(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setSessions([]);
      } else {
        setSessions(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    }
  };

  /**
   * Get sessions
   * @returns 
   */
  const getTerms = async () => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await termApi.getTerms(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setTerms([]);
      } else {
        setTerms(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    }
  };

  /**
   * Get All Stuents
   * @returns 
   */
  const getAllStudents = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.getStudents(schoolId, 0, 2000);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setStudents([]);
      } else {
        setStudents(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get Parents
   * @returns 
   */
  const getParents = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await parentsApi.getParents(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setParents([]);
      } else {
        setParents(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get All Class
   * @returns 
   */
  const getClasses = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const response = await classApi.getClasses('no');
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setClasses([]);
      } else {
        setClasses(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };


  /**
   * Get All Staff
   * @returns 
   */
  const getAllStaff = async () => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await staffApi.getStaff(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setStaff([]);
      } else {
        setStaff(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get fee details
   * @returns 
   */
  const getFeeDetails = async () => {
    setIsLoading(true);
    try {
      const response = await feeApi.getFeeDetail(feeId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Failed to get fee details."
        );
      }

      if (!empty(response_data) && !empty(response_data.response)) {
        const data = response_data.response;
        delete data.dateCreated;
        delete data.creator;

        // convert fields to camel case 
        const values = convertKeysToSnakeCase(data);
        delete values._id;
        delete values.school_id;
        setFeeDescription(values?.description || '');

        delete values.description;

        if (!empty(values?.class_ids)) {
          await getClasses();
        }

        if (!empty(values?.student_ids)) {
          await getAllStudents();
        }

        if (!empty(values?.staff_ids)) {
          await getAllStaff();
        }

        if (!empty(values?.parent_ids)) {
          await getParents();
        }

        values.status = values?.active || 'No';
        if (!empty(values?.start_date)) {
          values.start_date = getInputDateFormat(new Date(values?.start_date || ''));
        }
        if (!empty(values?.end_date)) {
          values.end_date = getInputDateFormat(new Date(values?.end_date || ''));
        }

        setFeeEntries((prev) => {
          const ids = []; 
          values?.fees?.forEach((item, idx) => {
            ids.push({ id: idx })
          })

          return ids;
        })
        const fees = isArray(values?.fees) ? values.fees : [];
        setFees(fees); 
        return setInitialValues((prev) => ({ ...prev, applicable_groups: [], class_ids: [], student_ids: [], parent_ids: [], days: [], ...values }));
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Handle submission
   * @param values
   */
  const handleSubmit = async (values) => {
    if (!isLoading) setIsLoading(true);
    try {
      if (empty(values)) {
        return responseDialog(
          "error",
          "Validation Error!",
          "Something went wrong! Try again later."
        );
      }

      if (values?.applicable_groups.includes('Class') && empty(values?.class_ids)) {
        return responseDialog(
          "error",
          "The 'Class' field is required",
          "Please select at least one class."
        );
      }
      if (values?.applicable_groups.includes('Staff') && empty(values?.staff_ids)) {
        return responseDialog(
          "error",
          "The 'Staff' field is required",
          "Please select at least one staff."
        );
      }
      if (values?.applicable_groups.includes('Parents') && empty(values?.parent_ids)) {
        return responseDialog(
          "error",
          "The 'Parent' field is required",
          "Please select at least one staff."
        );
      }
      if (values?.applicable_groups.includes('Students') && empty(values?.student_ids)) {
        return responseDialog(
          "error",
          "The 'Student' field is required",
          "Please select at least one student."
        );
      }

      values.fees = fees;
      values.description = feeDescription; 

      let response;
      let itemAdded = false;
      let itemUpdated = false;
      const payload = {
        fees,
        description: feeDescription,
        title: values?.title || '',
        applicable_groups: isArray(values.applicable_groups) ? values.applicable_groups : [],
        class_ids: isArray(values.class_ids) ? values.class_ids : [],
        student_ids: isArray(values.student_ids) ? values.student_ids : [],
        staff_ids: isArray(values.staff_ids) ? values.staff_ids : [],
        term_id: values?.term_id || '',
        session_id: values?.session_id || '',
        start_date: values?.start_date || '',
        end_date: values?.end_date || '',
        status: values?.status || ''

      }
      if (!feeId) {
        response = await feeApi.addFee(payload);
        itemAdded = true;
      } else {
        response = await feeApi.updateFee(
          feeId,
          payload
        );
        itemUpdated = true;
      }
      const response_data = prepareResponseData(response);
      if (!response_data?.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!"
        );
      }

      navigate("/fees/list-fees", {
        state: { itemAdded, itemUpdated },
      });
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Handle input type for fee category and amount
   */
  const handleInputType = (name, setFieldValue, index) => (e) => {
    const value = e.target?.value || "";
    
    setFees((prevFees) => {
      // Ensure prevFees is an array
      const newFees = Array.isArray(prevFees) ? [...prevFees] : new Array(feeEntries.length).fill({});
      
      // Ensure the index exists in newFees
      if (!newFees[index]) {
        newFees[index] = {};
      }

      // Update the specific field
      if (name.includes('category_id')) {
        newFees[index] = { ...newFees[index], category_id: value };
      } else if (name.includes('amount')) {
        newFees[index] = { ...newFees[index], amount: value };
      }
      
      return newFees;
    });

    // Update Formik values
    setFieldValue(name, value);
  };

  const updateInputFields = async (inputValues) => {
    if (inputValues.includes('Students')) {
      if (empty(students)) {
        return await getAllStudents();
      }
    }

    if (inputValues.includes('Class')) {
      if (empty(classes)) {
        return await getClasses();
      }
    }

    if (inputValues.includes('Staff')) {
      if (empty(staff)) {
        return await getAllStaff();
      }
    }

    if (inputValues.includes('Parents')) {
      if (empty(parents)) {
        return await getParents();
      }
    }
  }

  const handleMultiSelectChange = async (name, newValue, setFieldValue) => {
    try {
      const inputValues = !empty(newValue) && isArray(newValue) ? newValue : [];
      setFieldValue(name, inputValues);
  
      await updateInputFields(inputValues);
    } catch (error) {}
  }

    /**
   * Add a new fee entry
   */
  const addFeeEntry = () => {
    try {
      if (feeEntries.length < feeCategories.length) {
        const newId = feeEntries.length + 1;
        setFeeEntries((prev) => [...prev, { id: newId }]);
        setFees((prev) => [...(Array.isArray(prev) ? prev : []), {}]);
      } else {
        responseDialog("error", "Error Alert", `Maximum of ${feeCategories?.length || 0} fee entries allowed.`);
      }
    } catch (error) {}
  };

  /**
   * Remove a fee entry
   */
  const removeFeeEntry = (id) => {
    try {
      if (feeEntries.length > 1) {
        const index = feeEntries.findIndex((entry) => entry.id === id);
        setFeeEntries((prev) => prev.filter((entry) => entry.id !== id));
        setFees((prev) => {
          const newFees = Array.isArray(prev) ? [...prev] : [];
          newFees.splice(index, 1);
          return newFees;
        });
      }
    } catch (error) {}
  };

  return (
    <>
      <FeeWrapper {...props}>
        <main>
          <div className="container flex-center-top">
            <MainHeader
              title={
                !empty(feeId)
                  ? "Update Fee"
                  : "Add Fee"
              }
            />
            <div className="form-container mt-30">
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
              {({ values, setFieldValue }) => (
                <Form style={{ width: "100%" }}>
                  <div className="app_input_group">
                    <InputField
                      placeholder="Enter Fee Type Title E.g School Fees, Portal Levy etc."
                      name="title"
                      height={50}
                      labelTitle="Title"
                      required={true}
                    />
                    <MultiSelectField
                      labelTitle="Applicable Groups"
                      placeholder="Select Applicable Groups"
                      name="applicable_groups"
                      options={applicableGroups || []}
                      selectedOptions={values.applicable_groups || []}
                      required={true}
                      height={50}
                      mt="mt-10"
                      onChange={(e) =>
                        handleMultiSelectChange(
                          "applicable_groups",
                          e.value,
                          setFieldValue
                        )
                      }
                    />
                  </div>
                    
                  {!empty(values?.applicable_groups) &&
                    <div>
                      {String(values?.applicable_groups).includes("Class") && (
                        <div className="app_input_group mb-40">
                          <MultiSelectField
                            labelTitle="Class(es)"
                            placeholder="Select Class(es)"
                            name="class_ids"
                            options={classes || []}
                            selectedOptions={values?.class_ids || []}
                            required={true}
                            height={50}
                            mt="mt-10"
                            onChange={(e) =>
                              handleMultiSelectChange(
                                "class_ids",
                                e.value,
                                setFieldValue
                              )
                            }
                          /> 
                        </div>
                      )}
                      { String(values?.applicable_groups).includes('Student') && 
                        <div className="app_input_group mb-40">
                          <MultiSelectField
                            labelTitle="Student(s)"
                            placeholder="Select Student(s)"
                            name="student_ids"
                            options={students || []}
                            selectedOptions={values?.student_ids || []}
                            valueKey="_id"
                            required={true}
                            height={50}
                            optionLabel="fullNameClassTitle"
                            mt="mt-10"
                            onChange={(e) =>
                              handleMultiSelectChange(
                                "student_ids",
                                e.value,
                                setFieldValue
                              )
                            }
                          />
                        </div>
                      }
                      { String(values?.applicable_groups).includes('Staff') && 
                        <div className="app_input_group mb-40">
                          <MultiSelectField
                            labelTitle="Staff"
                            placeholder="Select Staff"
                            name="staff_ids"
                            options={staff || []}
                            selectedOptions={values?.staff_ids || []}
                            valueKey="_id"
                            required={true}
                            height={50}
                            optionLabel="fullName"
                            mt="mt-10"
                            onChange={(e) =>
                              handleMultiSelectChange(
                                "staff_ids",
                                e.value,
                                setFieldValue
                              )
                            }
                          />
                        </div>
                      }
                    </div>
                    }
                    
                  <Header4 children={"Fees"} />
                  <div 
                    className={`flex flex-start col-g-8 pointer ${feeEntries.length >= 5 ? "disabled" : ""}`}
                    style={{ color: feeEntries.length >= feeCategories?.length ? colors.gray : colors.primary }}
                    onClick={feeEntries.length < 5 ? addFeeEntry : undefined}
                  >
                    <span>Add Fee</span>
                    <FaPlus style={{ marginTop: 2 }} />
                  </div>
                  {/* Dynamically render fee entries */}
                  
                  <div style={{ border: `2px dotted ${colors.primary}`, paddingLeft: 15, paddingRight: 15, paddingBottom: 20, marginTop: 20 }}>
                    {feeEntries.map((entry, index) => (
                      <div key={entry.id} className="fee-entry">
                        <div className="app_input_group">
                          <SelectField
                            labelTitle="Category"
                            required={true}
                            placeholder="Select Fee Category"
                            name={`fees[${index}].category_id`}
                            options={feeCategories || []}
                            height={50}
                            valueKey="id"
                            containerWidth={350}
                            selectedOption={fees[index]?.category_id || ""}
                            handleChangeFunc={handleInputType(
                              `fees[${index}].category_id`,
                              setFieldValue,
                              index
                            )}
                          />
                          <InputFieldChange
                            placeholder="Enter Amount"
                            name={`fees[${index}].amount`}
                            height={50}
                            containerWidth={200}
                            type="number"
                            labelTitle="Amount"
                            marginTop={9}
                            required={true}
                            onChange={handleInputType(
                              `fees[${index}].amount`,
                              setFieldValue,
                              index
                            )}
                          />
                          {feeEntries.length > 1 && (
                            <FaTimesCircle 
                              style={{ color: colors.danger, marginLeft: 5, height: 40, marginTop: 40 }}
                              onClick={() => removeFeeEntry(entry.id, setFieldValue)}
                              size={26}
                              className="pointer"
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="app_input_group">
                    <SelectField
                      labelTitle="Session"
                      required={true}
                      placeholder="Select Session"
                      name="session_id"
                      options={sessions || []}
                      height={50}
                      valueKey="_id"
                      containerWidth={300}
                      selectedOption={values?.session_id || ""}
                      handleChangeFunc={handleInputType(
                        "session_id",
                        setFieldValue
                      )}
                    />
                  </div>
                  <div className="app_input_group mb-20">
                    <SelectField
                      labelTitle="Term"
                      required={true}
                      placeholder="Select Term"
                      name="term_id"
                      options={terms || []}
                      height={50}
                      valueKey="_id"
                      containerWidth={300}
                      selectedOption={values?.term_id || ""}
                      handleChangeFunc={handleInputType(
                        "term_id",
                        setFieldValue
                      )}
                    />
                  </div>
                  <Header4>
                    <span className="fs-16">
                      Description (Optional)
                    </span>
                  </Header4>
                  <div style={{ width: '100%' }}>
                    <Editor value={feeDescription} onTextChange={(e) => setFeeDescription(e.htmlValue)} style={{ height: '320px', backgroundColor: colors.white }} />
                  </div>
                  <div className="app_input_group">
                    <InputField
                      placeholder="Enter Start Date"
                      name="start_date"
                      height={50}
                      type="date"
                      containerWidth={300}
                      labelTitle="Start Date"
                    />
                    <InputField
                      placeholder="Enter End Date"
                      name="end_date"
                      type="date"
                      containerWidth={300}
                      height={50}
                      labelTitle="End Date"
                    />
                  </div>
                  <div className="app_input_group">
                    <SelectField
                      labelTitle="Active"
                      required={true}
                      placeholder="Select Option"
                      name="status"
                      options={yesNo || []}
                      height={50}
                      valueKey="title"
                      containerWidth={300}
                      selectedOption={values?.status || ''}
                      handleChangeFunc={handleInputType(
                        "status",
                        setFieldValue
                      )}
                      />
                  </div>
                  
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <ButtonIcon
                      height={45}
                      marginTop={5}
                      color="#ffffff"
                      backgroundColor="#633ccd"
                      width={300}
                      borderColor="#633ccd"
                      buttonText={
                        feeId ? "Update Fee" : "Add Fee"
                      }
                      type="submit"
                    />
                  </div>
                </Form>
              )}
              </Formik>
            </div>
          </div>
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
        <Toast ref={toastTR} position="bottom-left" />
      </FeeWrapper>
    </>
  );
};

export default AddUpdateFee;
